import { Group, Paper } from "@mantine/core"
import classes from "./QuestionSelect.module.css"
import type { TQuestionProps } from "./types"

export function QuestionSelect({
  question,
  value,
  preview,
  setValue,
  choices,
  selected,
}: TQuestionProps & {
  selected?: (idx: number) => boolean
  choices?: string[]
}) {
  choices = choices ?? question.meta.choices
  selected = selected || ((idx) => value === idx)

  return (
    <Group gap="xs">
      {choices?.map((choice, idx) => (
        <>
          <Paper
            key={choice}
            radius="md"
            className={classes.variant}
            onClick={() => setValue(idx)}
            ta={choice.length > 20 ? "left" : "center"}
            data-preview={preview ? "true" : undefined}
            data-selected={selected(idx) ? "true" : undefined}
          >
            {choice}
          </Paper>
        </>
      ))}
    </Group>
  )
}
